import { createContext } from "react";
import type { FieldDestinationStore } from "./fieldDestinationStore.ts";

export const FieldDestinationContext = createContext<FieldDestinationStore | undefined>(undefined);
